import React from "react";
import { useFeature } from "../../../../common/FeatureFlags.js";
import { RestrictedByCapabilityWithDebug } from "../../../auth/RestrictedByCapability.js";
import { RestrictedByOrganisationPermissionWithDebug } from "../../../auth/RestrictedByOrganisationPermission.js";
import { useUserData } from "../../../auth/useUserData.js";
import { TemplateQuotePublishingIcon } from "./TemplateQuotePublishingStatus.js";
import { TemplateQuoteStatuses_QuoteTemplateFragment } from "./TemplateQuoteStatuses.generated.js";
import { TemplateQuoteSubscriptionStatusIcon } from "./TemplateQuoteSubscriptionStatus.js";

export const useTemplateQuoteStatuses = () => {
  const viewer = useUserData().currentUser!;

  const getTemplateQuoteStatusIcons = (
    doc: TemplateQuoteStatuses_QuoteTemplateFragment
  ) => {
    const isOwnTemplate =
      viewer.organisation.id === doc.owningSystemOrganisationId;
    const haveExplicitAccess = doc.accessType === "explicit";

    const statusIcons: React.ReactNode[] = [
      !isOwnTemplate && haveExplicitAccess && (
        <TemplateQuoteSubscriptionStatusIcon
          doc={doc}
          key={"template-subscribe-status"}
        />
      ),
      isOwnTemplate && doc.hasAnyPublishedVersion && (
        <TemplateQuotePublishingIcon
          showOnlyPublishedStatus={true}
          doc={doc}
          key={"template-share-status"}
        />
      ),
    ].filter(Boolean);

    return statusIcons;
  };

  return { getTemplateQuoteStatusIcons };
};
